
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnCheck from "@/components/scope/btn-check.vue";
import SelectPurchaseModal from "./component/select-purchase-modal.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const supplier = namespace("supplier");
const purchase = namespace("purchase");
const finance = namespace("finance");

@Component({
  components: { BtnCheck, SelectPurchaseModal }
})
export default class ServiceEdit extends Vue {
  @app.Mutation setPBPX;
  @supplier.Action getSupplierList;
  @supplier.Action getSupplierDetail;
  @supplier.Action createSupplier;
  @staff.Action getStaffList;
  @finance.Action savePurchaseBill;
  @finance.Action queryPurchaseBillDetail;
  @parts.Action getPartsDetail;
  @inventory.Action getInventoryListByParts;
  @purchase.Action getPurchaseDetail;
  @purchase.Action purchaseComplete;
  @user.State userData;
  @base.Action getDictionaryList;
  @purchase.Action savePurchase;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  orderFormData: any = {};
  orderFormDataRules: any = {
    supplierCode: {
      required: true,
      message: t("finance.please-select-supplier"),
      trigger: "change"
    }
  };
  supplierList: any = [];
  shwoSelectPurchaseModal: boolean = false;
  get breadData() {
    return [
      { name: this.$t("finance.procurement-settlement"), path: "/finance/purchase-settlement" },
      {
        name: this.isAdd ? this.$t("finance.new-statement") : this.$t("finance.edit-statement")
      }
    ];
  }
  get isAdd() {
    return this.$route.name === "purchaseSettlementBillAdd";
  }
  get orderId() {
    return this.$route.params.id;
  }
  get seletedPurchaseAmount() {
    const amount = this.selectedPurchaseList.reduce((prev, next) => {
      return prev + Number(next.purchaseAmount);
    }, 0);
    return amount.i18nToFixed();
  }
  created() {
    this.init();
  }
  init() {
    this.searchSupplierList();
    if (!this.isAdd) {
      this.setEditData();
    }
  }
  setEditData() {
    this.queryPurchaseBillDetail({
      billNo: this.orderId
    }).then(data => {
      data = data.data || {};
      this.supplierList = [
        {
          supplierCode: data.supplierCode,
          supplierName: data.supplierName
        }
      ];
      this.seletedSupplierData = {
        supplierCode: data.supplierCode,
        supplierName: data.supplierName
      };
      this.selectedPurchaseList = data.orderList;
      this.selectedPurchaseNoList = data.orderList.map(item => item.purchaseNo);
      this.orderFormData = Object.assign(data, {
        supplierCode: data.supplierCode
      });
    });
  }
  searchSupplierList(val = "") {
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      supplierName: val
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []);
    });
  }
  seletedSupplierData: any = {};
  handleSupplierChange(val) {
    if (!val) {
      this.seletedSupplierData = {};
    } else {
      this.getSupplierDetail({
        supplierCode: val
      }).then(data => {
        this.seletedSupplierData = data.data;
      });
      this.selectedPurchaseList = [];
      this.selectedPurchaseNoList = [];
    }
  }
  handleShowSelectModal() {
    this.shwoSelectPurchaseModal = true;
  }
  selectedPurchaseList: any = [];
  selectedPurchaseNoList: any = [];
  handleReceiveRows(rows) {
    const temp = [];
    rows.forEach(purchase => {
      if (!this.selectedPurchaseNoList.includes(purchase.purchaseNo)) {
        this.selectedPurchaseNoList.push(purchase.purchaseNo);
        temp.push(purchase);
      }
    });
    this.selectedPurchaseList.push(...temp);
  }
  handleRemoveRow(index) {
    this.selectedPurchaseList.splice(index, 1);
    this.selectedPurchaseNoList.splice(index, 1);
  }
  handleAddBill() {
    (this.$refs.refSupplier as any).validate(valid => {
      if (valid) {
        this.btnStartLoading();
        this.savePurchaseBill({
          billNo: this.orderFormData.billNo,
          billAmount: this.seletedPurchaseAmount,
          supplierCode: this.seletedSupplierData.supplierCode,
          supplierName: this.seletedSupplierData.supplierName,
          purchaseNos: this.selectedPurchaseList.map(item => item.purchaseNo)
        })
          .then(() => {
            this.$message.success(this.$t("finance.new-success") as string);
            this.$router.push("/finance/purchase-settlement");
          })
          .finally(() => {
            this.btnStopLoading();
          });
      }
    });
  }
}
